import axios from "axios";
import * as ActionType from "./giftTransaction.type";
import { apiInstanceFetch } from "../../../util/api";

// Returns a promise of the server's total so the table can page through all
// transactions (it used to show only the first 20 of the newest 50).
export const getGiftTransaction = (page = 1, limit = 25) => (dispatch) => {
  return apiInstanceFetch
    .get(`giftTransaction/admin/getAllTransactions?page=${page}&limit=${limit}`)
    .then((res) => {
      dispatch({
        type: ActionType.GET_GIFT_TRANSACTION,
        payload: res.transactions || [],
      });
      return Number(res.total || 0);
    })
    .catch((error) => {
      console.error(error);
      return 0;
    });
};

export const getTransactionStats = () => (dispatch) => {
  apiInstanceFetch
    .get(`giftTransaction/admin/getStats`)
    .then((res) => {
      dispatch({
        type: ActionType.GET_TRANSACTION_STATS,
        payload: res.stats || {},
      });
    })
    .catch((error) => console.error(error));
};
